


















































import {Vue, Component , Prop} from 'vue-property-decorator';
import { LetterOwnerWithSendingInformationAndAttachments } from '@/store/models/LetterOwner/LetterOwnerWithSendingInformationAndAttachments';
import { AutoCompleteData } from '@/store/models/Letter/AutoCompleteData';
import File from '@/store/models/Letter/File';
import LetterAttachmentMobile from '@/components/MobileComponents/LetterDetailsMobile/LetterAttachmentMobile/LetterAttachmentMobile.vue';
import * as util from '@/util/utils.ts';
import * as $ from 'jquery';
import FileSelector from '@/components/UiComponents/FileSelector.vue';
import * as autoCompleteDataService from '@/store/Services/autoCompleteDataService.ts';
import SimpleLookupMobile from '@/components/MobileComponents/EnterpriseFormMobile/SimpleLookupMobile/SimpleLookupMobile.vue';
import { ValidValuesForSingleColumn, ValidValues } from '@/store/models/EnterpriseForm/EnterpriseFormValidValues';
import CommentEditorMobile from '@/components/MobileComponents/ForwardLetterMobile/RecipientSelectorMobile/CommentEditorMobile/CommentEditorMobile.vue';

@Component({
    components: { LetterAttachmentMobile, FileSelector ,SimpleLookupMobile, CommentEditorMobile}
})
export default class SingleSelectedRecipientMobile extends Vue{
    isTelegramActive = false;
    isMailActive = false;
    isSmsActive = false;
    loadingFile = false;
    loadedPercent = 0;
    currentAttachedFileName = '';
    get fileInputId(){
        if(this.recipient)
            return 'file-' + this.recipient.id;
        return '';
    }

    get dataListId(){
         if(this.recipient)
            return 'list-' + this.recipient.id;
        return '';
    }
    
    @Prop() recipient?: LetterOwnerWithSendingInformationAndAttachments;
    autoCompleteData = [] as AutoCompleteData[];
    @Prop() autoCompleteDataType?: string;
    async mounted(){
           if(this.autoCompleteDataType === 'all')
            this.autoCompleteData =  await autoCompleteDataService.getForwardingAutoCompleteData();
         else if(this.autoCompleteDataType === 'copy')
            this.autoCompleteData = await autoCompleteDataService.getSendCopyAutoCompleteData();
         else if(this.autoCompleteDataType === 'draft')
            this.autoCompleteData = await autoCompleteDataService.getSendDraftAutoCompleteData();
    }
    get autoCompleteValidValues(){
        const result = [] as ValidValues[];
        if(!this.autoCompleteData)return result;
        this.autoCompleteData.forEach(d=>{
            const validVal = {} as ValidValues;
            validVal.item1 = d.id;
            validVal.item2 = d.name;
            result.push(validVal);
        });
        return result;
    }
    remove(){
        if(this.recipient)
            this.$emit('recipient-removed',this.recipient.id);
    }
    toggleTelegram(){
        if(!this.recipient)return;
        this.recipient.shallReceiveMessageViaMessagingApp = !this.recipient.shallReceiveMessageViaMessagingApp;
    }
    toggleSms(){
        if(!this.recipient)return;
        this.recipient.shallReceiveSms = !this.recipient.shallReceiveSms
        
    }
    toggleMail(){
        this.isMailActive = !this.isMailActive;
        if(this.recipient){
            if(this.recipient.emails.length > 0 && this.isMailActive )
                this.recipient.emails[0].canBeUsedForSending = true;
            else{
                this.recipient.emails.forEach(mail=>{mail.canBeUsedForSending = false;});
            }
        }
    }
    paraph(){
        if(this.recipient)
            this.$emit("paraph",this.recipient.id);
    }
    onFileSelectorChanged(file: any){
        const reader = new FileReader();
        reader.addEventListener("progress",(evt)=>{
            this.loadedPercent = (evt.loaded / evt.total) * 100;
        });
        reader.addEventListener("loadend",(x)=>{
            const attachedFile = {} as File;
            if(x.target && this.recipient)
            {
                attachedFile.id = '00000000-0000-0000-0000-000000000000';
                attachedFile.extension = file.name;
                attachedFile.content = (x.target as any).result;
                this.recipient.attachments.push(attachedFile);
            }
            this.loadingFile = false;
        });
        
        this.loadingFile = true;
        reader.readAsDataURL(file);
        
    }
    onFileChanged(e: any){
        if(!this.recipient)return;
        const file = e.target.files[0];
        this.currentAttachedFileName = file.currentAttachedFileName;
        const reader = new FileReader();
        reader.addEventListener("progress",(evt)=>{
            this.loadedPercent = (evt.loaded / evt.total) * 100;
        });
        reader.addEventListener("loadend",(x)=>{
            const attachedFile = {} as File;
            if(x.target && this.recipient)
            {
                attachedFile.id = '00000000-0000-0000-0000-000000000000';
                attachedFile.extension = file.name;
                attachedFile.content = (x.target as any).result;
                this.recipient.attachments.push(attachedFile);
            }
            this.loadingFile = false;
        });
        
        this.loadingFile = true;
        reader.readAsDataURL(file);
    }

    onAttachmentRemoved(index: number){
        if(this.recipient){
            this.recipient.attachments.splice(index,1);
        }
    }

    onValueSelected(val: ValidValues){
        if(!this.recipient)return;
        this.recipient.forwardingComment = val.item2;
    }

    onValueCleared(){
        if(!this.recipient)return;
        this.recipient.forwardingComment = "";
    }
    onCommentChanged(comment: string){
        
         if(!this.recipient)return;
        this.recipient.forwardingComment = comment;
    }
   
}
